import React, { useState, useEffect } from 'react';

const API = 'https://groovie-business-api-production.up.railway.app/api/v1';

const Svg = ({ type, size = 16 }) => {
  const icons = {
    shield: <><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></>,
    check: <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22,4 12,14.01 9,11.01"/></>,
    alert: <><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
    xCircle: <><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></>,
    monitor: <><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></>,
    download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
    clock: <><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></>,
    eye: <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
    refresh: <><polyline points="23,4 23,10 17,10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></>,
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{icons[type]}</svg>;
};

var severityColors = {
  info: { bg: '#eff6ff', text: '#1e40af', border: '#bfdbfe' },
  warning: { bg: '#fffbeb', text: '#92400e', border: '#fde68a' },
  violation: { bg: '#fef2f2', text: '#991b1b', border: '#fecaca' },
};

var eventLabels = {
  license_signed: 'License Signed',
  license_revoked: 'License Revoked',
  device_registered: 'Device Registered',
  device_deactivated: 'Device Deactivated',
  device_auto_deactivated: 'Device Auto-Deactivated',
  stream_start: 'Stream Started',
  ip_mismatch: 'IP Mismatch',
  unauthorized_access: 'Unauthorized Access',
  expired_subscription_streaming: 'Expired Sub Streaming',
  tier_location_exceeded: 'Tier Limit Exceeded',
  unsigned_streaming: 'Unsigned Streaming',
};

export default function Compliance() {
  var token = localStorage.getItem('token');
  var headers = { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' };
  var companyId = null;
  try {
    companyId = JSON.parse(atob(token.split('.')[1])).company_id;
  } catch (e) {}

  var _s1 = useState(null); var summary = _s1[0]; var setSummary = _s1[1];
  var _s2 = useState([]); var logs = _s2[0]; var setLogs = _s2[1];
  var _s3 = useState([]); var devices = _s3[0]; var setDevices = _s3[1];
  var _s4 = useState(true); var loading = _s4[0]; var setLoading = _s4[1];
  var _s5 = useState(null); var toast = _s5[0]; var setToast = _s5[1];
  var _s6 = useState('all'); var logFilter = _s6[0]; var setLogFilter = _s6[1];

  useEffect(function() { loadAll(); }, []);
  useEffect(function() { if (toast) { var t = setTimeout(function() { setToast(null); }, 4000); return function() { clearTimeout(t); }; } }, [toast]);

  function loadAll() {
    if (!companyId) return;
    setLoading(true);
    Promise.all([
      fetch(API + '/licenses/compliance/summary/' + companyId, { headers }).then(function(r) { return r.ok ? r.json() : null; }),
      fetch(API + '/licenses/compliance/' + companyId + '?limit=100', { headers }).then(function(r) { return r.ok ? r.json() : null; }),
      fetch(API + '/licenses/devices/' + companyId, { headers }).then(function(r) { return r.ok ? r.json() : null; }),
    ]).then(function(results) {
      if (results[0]) setSummary(results[0]);
      if (results[1]) setLogs(results[1].logs || []);
      if (results[2]) setDevices(results[2].devices || []);
      setLoading(false);
    }).catch(function() { setLoading(false); });
  }

  function handleExport() {
    window.open(API + '/licenses/compliance/export/' + companyId + '?format=csv', '_blank');
  }

  function formatDate(iso) {
    if (!iso) return '\u2014';
    var d = new Date(iso);
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) + ' ' + d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }

  function timeAgo(iso) {
    if (!iso) return 'Never';
    var diff = Date.now() - new Date(iso).getTime();
    var mins = Math.floor(diff / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return mins + 'm ago';
    var hours = Math.floor(mins / 60);
    if (hours < 24) return hours + 'h ago';
    return Math.floor(hours / 24) + 'd ago';
  }

  var filteredLogs = logFilter === 'all' ? logs : logs.filter(function(l) { return l.severity === logFilter; });

  if (loading) {
    return (
      <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 48, height: 48, borderRadius: '50%', border: '3px solid #e9d5ff', borderTopColor: '#7c3aed', animation: 'spin 0.8s linear infinite' }} />
        <style>{'@keyframes spin { to { transform: rotate(360deg); } }'}</style>
      </div>
    );
  }

  var score = summary ? summary.health_score : 0;
  var scoreColor = score >= 90 ? '#059669' : score >= 70 ? '#d97706' : score >= 50 ? '#ea580c' : '#dc2626';
  var scoreBg = score >= 90 ? '#ecfdf5' : score >= 70 ? '#fffbeb' : score >= 50 ? '#fff7ed' : '#fef2f2';

  return (
    <div style={{ padding: '32px 40px', maxWidth: 1200, margin: '0 auto', fontFamily: "'Outfit', 'DM Sans', sans-serif" }}>

      {toast && (
        <div style={{
          position: 'fixed', top: 24, right: 24, zIndex: 100, padding: '14px 24px', borderRadius: 12,
          fontSize: 14, fontWeight: 600, boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          background: toast.type === 'success' ? '#ecfdf5' : '#fef2f2',
          color: toast.type === 'success' ? '#065f46' : '#991b1b',
        }}>{toast.message}</div>
      )}

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 26, fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>Compliance & Monitoring</h1>
          <p style={{ fontSize: 14, color: '#9ca3af', marginTop: 4 }}>License status, device monitoring, and audit trail</p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={loadAll} style={{
            padding: '8px 16px', borderRadius: 10, border: '1.5px solid #e5e7eb', background: '#fff',
            fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
            color: '#374151', fontFamily: "'Outfit',sans-serif",
          }}>
            <Svg type="refresh" size={14} /> Refresh
          </button>
          <button onClick={handleExport} style={{
            padding: '8px 16px', borderRadius: 10, border: 'none',
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)',
            fontSize: 13, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6,
            color: '#fff', fontFamily: "'Outfit',sans-serif",
          }}>
            <Svg type="download" size={14} /> Export Audit Log
          </button>
        </div>
      </div>

      {/* Health Score + Summary Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: '200px 1fr', gap: 20, marginBottom: 28 }}>
        {/* Score Circle */}
        <div style={{
          background: scoreBg, borderRadius: 16, padding: 28, textAlign: 'center',
          border: '1px solid ' + scoreColor + '33',
        }}>
          <div style={{
            width: 100, height: 100, borderRadius: '50%', margin: '0 auto 12px',
            border: '6px solid ' + scoreColor,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 32, fontWeight: 800, color: scoreColor,
          }}>
            {score}
          </div>
          <p style={{ fontSize: 16, fontWeight: 700, color: scoreColor, margin: '0 0 2px', textTransform: 'capitalize' }}>
            {summary ? summary.health_status : 'N/A'}
          </p>
          <p style={{ fontSize: 12, color: '#9ca3af', margin: 0 }}>Health Score</p>
        </div>

        {/* Summary Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14 }}>
          {[
            {
              icon: 'shield', label: 'License', value: summary && summary.license.active ? 'Active' : 'Not Signed',
              sub: summary && summary.license.active ? 'v' + summary.license.version : 'Action needed',
              color: summary && summary.license.active ? '#059669' : '#dc2626',
              bg: summary && summary.license.active ? '#ecfdf5' : '#fef2f2',
            },
            {
              icon: 'monitor', label: 'Active Devices', value: summary ? summary.devices.active : 0,
              sub: summary && summary.devices.stale > 0 ? summary.devices.stale + ' stale' : 'All healthy',
              color: '#2563eb', bg: '#eff6ff',
            },
            {
              icon: 'xCircle', label: 'Violations', value: summary ? summary.violations.last_30_days : 0,
              sub: 'Last 30 days',
              color: summary && summary.violations.last_30_days > 0 ? '#dc2626' : '#059669',
              bg: summary && summary.violations.last_30_days > 0 ? '#fef2f2' : '#ecfdf5',
            },
            {
              icon: 'alert', label: 'Warnings', value: summary ? summary.warnings.last_30_days : 0,
              sub: 'Last 30 days',
              color: summary && summary.warnings.last_30_days > 0 ? '#d97706' : '#059669',
              bg: summary && summary.warnings.last_30_days > 0 ? '#fffbeb' : '#ecfdf5',
            },
          ].map(function(card) {
            return (
              <div key={card.label} style={{
                background: '#fff', borderRadius: 14, padding: '20px 18px',
                border: '1px solid #e5e7eb',
              }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 10, marginBottom: 10,
                  background: card.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: card.color,
                }}>
                  <Svg type={card.icon} size={18} />
                </div>
                <p style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af', margin: '0 0 2px', textTransform: 'uppercase', letterSpacing: 0.5 }}>{card.label}</p>
                <p style={{ fontSize: 22, fontWeight: 800, color: '#111827', margin: '0 0 2px' }}>{card.value}</p>
                <p style={{ fontSize: 12, color: card.color, fontWeight: 600, margin: 0 }}>{card.sub}</p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Two column: Devices + Logs */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>

        {/* Devices */}
        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '18px 24px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', margin: 0 }}>Registered Devices</h3>
            <span style={{ fontSize: 12, fontWeight: 600, color: '#9ca3af' }}>{devices.length} total</span>
          </div>
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            {devices.length === 0 && (
              <div style={{ padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>No devices registered yet</div>
            )}
            {devices.map(function(d) {
              var isStale = d.is_active && d.last_seen_at && (Date.now() - new Date(d.last_seen_at).getTime()) > 3 * 86400000;
              return (
                <div key={d.id} style={{
                  padding: '14px 24px', borderBottom: '1px solid #f9fafb',
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{
                      width: 8, height: 8, borderRadius: '50%',
                      background: d.is_active ? (isStale ? '#f59e0b' : '#22c55e') : '#d1d5db',
                    }} />
                    <div>
                      <p style={{ fontSize: 14, fontWeight: 600, color: '#111827', margin: 0 }}>{d.device_name || 'Unnamed Device'}</p>
                      <p style={{ fontSize: 12, color: '#9ca3af', margin: 0 }}>{d.location_name || 'Location ' + d.location_id} &middot; {d.device_type}</p>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <p style={{ fontSize: 12, color: isStale ? '#f59e0b' : '#9ca3af', fontWeight: isStale ? 600 : 400, margin: 0 }}>
                      {d.is_active ? timeAgo(d.last_seen_at) : 'Inactive'}
                    </p>
                    {d.ip_address && <p style={{ fontSize: 11, color: '#d1d5db', margin: 0 }}>{d.ip_address}</p>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Audit Log */}
        <div style={{ background: '#fff', borderRadius: 16, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '18px 24px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', margin: 0 }}>Audit Log</h3>
            <div style={{ display: 'flex', gap: 6 }}>
              {['all', 'violation', 'warning', 'info'].map(function(f) {
                return (
                  <button key={f} onClick={function() { setLogFilter(f); }} style={{
                    padding: '4px 12px', borderRadius: 8, border: 'none', fontSize: 11, fontWeight: 600,
                    background: logFilter === f ? '#7c3aed' : '#f3f4f6',
                    color: logFilter === f ? '#fff' : '#6b7280',
                    cursor: 'pointer', fontFamily: "'Outfit',sans-serif", textTransform: 'capitalize',
                  }}>{f}</button>
                );
              })}
            </div>
          </div>
          <div style={{ maxHeight: 400, overflowY: 'auto' }}>
            {filteredLogs.length === 0 && (
              <div style={{ padding: 32, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>No events found</div>
            )}
            {filteredLogs.map(function(log, idx) {
              var sev = severityColors[log.severity] || severityColors.info;
              return (
                <div key={log.id || idx} style={{
                  padding: '12px 24px', borderBottom: '1px solid #f9fafb',
                  display: 'flex', alignItems: 'flex-start', gap: 12,
                }}>
                  <div style={{
                    marginTop: 2, width: 8, height: 8, borderRadius: '50%', flexShrink: 0,
                    background: sev.text,
                  }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: '#111827' }}>
                        {eventLabels[log.event_type] || log.event_type}
                      </span>
                      <span style={{
                        padding: '2px 8px', borderRadius: 6, fontSize: 10, fontWeight: 700,
                        background: sev.bg, color: sev.text, textTransform: 'uppercase',
                      }}>{log.severity}</span>
                    </div>
                    {log.event_detail && <p style={{ fontSize: 12, color: '#6b7280', margin: '2px 0 0', lineHeight: 1.4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{log.event_detail}</p>}
                    <p style={{ fontSize: 11, color: '#d1d5db', margin: '3px 0 0' }}>
                      {formatDate(log.created_at)}{log.ip_address ? ' \u00B7 ' + log.ip_address : ''}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
